export const MapImg = '/assets/img/map-img.png'
